import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M15.47 8.97a.75.75 0 1 1 1.06 1.06l-5.299 5.3a.75.75 0 0 1-1.06 0L7.47 12.627a.75.75 0 0 1 1.06-1.06l2.171 2.17z" />
    <path
      fillRule="evenodd"
      d="M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25m0 1.5a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5"
      clipRule="evenodd"
    />
  </>
);

const CheckCircle = Icon('check-circle', svgContents);

export default CheckCircle;
